<cfp-login-card [title]="'loggedOut.title' | translate">
  <p class="mb-0" [innerHtml]="'loggedOut.body' | translate"></p>
</cfp-login-card>